import { create } from 'zustand';

/**
 * UI state for the Org Users page.
 *
 * The "Invite member" dialog is opened from two places — the in-page header
 * button on desktop and the OrgShell mobile topbar — so its open state has
 * to live outside the page component. Zustand keeps it light: no provider,
 * no context, no prop drilling through OrgShell → OrgTopbar.
 */
interface OrgUsersUiState {
  inviteDialogOpen: boolean;
  setInviteDialogOpen: (open: boolean) => void;
  openInviteDialog: () => void;
  closeInviteDialog: () => void;
}

export const useOrgUsersUiStore = create<OrgUsersUiState>((set) => ({
  inviteDialogOpen: false,
  setInviteDialogOpen: (open) => set({ inviteDialogOpen: open }),
  openInviteDialog: () => set({ inviteDialogOpen: true }),
  closeInviteDialog: () => set({ inviteDialogOpen: false }),
}));
